const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    sortBy: "default",
    filterBy: "all"
};

const filterSlice = createSlice({
    name: "blog",
    initialState,
    reducers: {
        sorted: (state, action) => {
            state.sortBy = action.payload;
        },
        filtered: (state, action) => {
            state.filterBy = action.payload;
        },
    },
});

export default filterSlice.reducer;
export const { sorted, filtered } = filterSlice.actions;
